import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import DynamicFormPage from '../../components/DynamicFormPage';
import { getAdminUserDetails, updateAdminUser } from '../../helpers/http_admin_users_requests';
import { useQuery } from '@tanstack/react-query';
import { brazilian_states } from '../../data/general_variables';

export default function AdminUserUpdate() {

    const { id } = useParams()

    const { data, isFetching } = useQuery({ queryKey: ['getAdminUserDetails', id], queryFn: () => getAdminUserDetails(id), staleTime: 1000 * 5 });

    const { user_admin_data: userData = [] } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Dados de Contato",
            fields: [
                {
                    name: "complete_name",
                    label: "Nome Completo",
                    type: "text",
                    required: true,
                },
                {
                    name: "whatsapp_number",
                    label: "Contato Principal",
                    type: "text",
                    mask: "phone",
                },
                {
                    name: "cpf",
                    label: "CPF",
                    type: "text",
                    mask: "cpf_cnpj",
                },
                {
                    name: "email",
                    label: "Email",
                    type: "email",
                    required: true,
                },
                {
                    name: "birth_date",
                    label: "Data de nascimento",
                    type: "date",
                    required: true,
                    InputLabelProps: { shrink: true }
                },
                {
                    name: "title",
                    label: "Cargo",
                    type: "text",
                    required: true,
                },
                {
                    name: "is_active",
                    label: "Status de Usuário",
                    type: "switch",
                },
                {
                    name: "observation",
                    label: "Observação",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                }
            ]
        },
        {
            title: "Dados Financeiros",
            fields: [
                {
                    name: "pix_key",
                    label: "Chave PIX",
                    type: "text",
                },
                {
                    name: "pix_key_description",
                    label: "Descrição",
                    type: "text",
                },
            ]
        },
        {
            title: "Endereço",
            fields: [
                {
                    name: "zip_code",
                    label: "CEP",
                    type: "text",
                    mask: "zipcode",
                    required: true,
                },
                {
                    name: "address",
                    label: "Endereço",
                    type: "text",
                    required: true,
                },
                {
                    name: "address_number",
                    label: "Número",
                    type: "text",
                    required: true,
                },
                {
                    name: "complement",
                    label: "Complemento",
                    type: "text",
                },
                {
                    name: "neighborhood",
                    label: "Bairro",
                    type: "text",
                    required: true,
                },
                {
                    name: "city",
                    label: "Cidade",
                    type: "text",
                    required: true,
                },
                {
                    name: "state",
                    label: "Estado",
                    type: "select",
                    required: true,
                    options: brazilian_states
                }
            ]
        },
        {
            title: "Contato de Emergência",
            fields: [
                {
                    name: "emergency_contact",
                    label: "Contato de Emergência",
                    type: "text",
                    mask: "phone",
                    required: true,
                },
                {
                    name: "emergency_contact_name",
                    label: "Nome do Contato",
                    type: "text",
                    required: true,
                },
                {
                    name: "emergency_contact_bond",
                    label: "Vínculo",
                    type: "text",
                    required: true,
                },
            ]
        },
    ];

    const navigate = useNavigate();

    const handleSubmit = (data) => {

        updateAdminUser(data, () => navigate('/usuarios'));
    };

    return <DynamicFormPage isLoading={isFetching} title={"Usuário  - Edição"} formFieldList={formFieldList} avatarUpload onCancel={() => navigate(-1)} initialData={userData} onSubmit={handleSubmit} />;

};
